// weather note for a tour (Open-Meteo, free, no key); null when offline / unavailable
const day = (ms) => new Date(ms).toISOString().slice(0, 10);
const WX = (c) => (c === 0 ? 'clear' : c <= 2 ? 'partly' : c === 3 ? 'cloudy' : c <= 48 ? 'fog' : c <= 57 ? 'drizzle' : c <= 67 ? 'rain' : c <= 77 ? 'snow' : c <= 82 ? 'showers' : 'thunder');

export async function tourWeather(tr) {
  const p = (tr.pts || []).find((x) => x.lat != null);
  if (!p || !navigator.onLine) return null;
  const old = Date.now() - tr.start > 6 * 864e5, d = day(tr.start);
  const q = `latitude=${p.lat.toFixed(3)}&longitude=${p.lon.toFixed(3)}&hourly=temperature_2m,weather_code,wind_speed_10m&timezone=UTC`;
  const url = old ? `https://archive-api.open-meteo.com/v1/archive?${q}&start_date=${d}&end_date=${d}` : `https://api.open-meteo.com/v1/forecast?${q}&past_days=7&forecast_days=1`;
  try {
    const ctl = new AbortController(), to = setTimeout(() => ctl.abort(), 6000);
    const j = await (await fetch(url, { signal: ctl.signal })).json();
    clearTimeout(to);
    const h = j.hourly, mid = (tr.start + (tr.end || tr.start)) / 2;
    let best = -1, bd = Infinity;
    (h?.time || []).forEach((tm, i) => { const dd = Math.abs(Date.parse(`${tm}Z`) - mid); if (dd < bd) { bd = dd; best = i; } });
    if (best < 0 || bd > 2 * 3.6e6 || h.temperature_2m[best] == null) return null;
    return { temp: Math.round(h.temperature_2m[best]), kind: WX(h.weather_code[best]), wind: Math.round(h.wind_speed_10m[best]) };
  } catch { return null; }
}
export const weatherText = (t, w) => (w ? `${w.temp} °C · ${t['wx_' + w.kind]} · ${t.wxWind} ${w.wind} km/h` : '');
